export const ApplicationSteps = {
  personalDetails: {
    paths: [
      '/apply/identityVerification',
      '/apply/personalDetails'
    ],
    title: 'Applicant details',
    stepNum: 1
  },
  businessDetails: {
    paths: [
      '/apply/businessList',
      '/apply/businessVerification',
      '/apply/businessDetails',
      // '/apply/businessFinancial',
      // '/apply/businessAddress',
      '/apply/businessDirectors'
    ],
    title: 'Business details',
    stepNum: 2
  },
  financialDetails: {
    paths: [
      // '/apply/documentDetails',
      '/apply/financialDetails'
    ],
    title: 'Banking details',
    stepNum: 3
  },
  fundingDetails: {
    paths: ['/apply/fundingDetails'],
    title: 'Done',
    stepNum: 4
  }
};
